// Notification settings section for the Administration page - a single
// sponsor email address that receives a notification whenever a new
// deviation or query is created (see services/auth/src/routes/
// notificationSettingsRoutes.ts and the notificationsClient.ts in
// safety/queries). Reachable by ADMIN and SPONSOR-tier roles
// (canEditNotificationSettings()), same access split as admin-import-view.ts.
import { notificationSettingsApi } from "./api-client.js";
import { escapeHtml, notify, $ } from "./dom.js";
import { canEditNotificationSettings } from "./state.js";

export async function renderNotificationSettingsSection(root: HTMLElement): Promise<void> {
  root.innerHTML = `<div class="loading">Chargement…</div>`;
  const settings = await notificationSettingsApi.get();
  const writable = canEditNotificationSettings();

  root.innerHTML = `
    <div class="section">
      <div class="section-header"><span class="title">📧 Notifications</span></div>
      <div class="section-body">
        <p class="field-hint">Cette adresse reçoit un email à chaque création d'une déviation ou d'une query.</p>
        <div class="form-group" style="max-width:360px">
          <label>Email du sponsor</label>
          <input type="email" id="notifSponsorEmail" value="${escapeHtml(settings.sponsorEmail || "")}" placeholder="sponsor@example.com" ${writable ? "" : "disabled"}>
        </div>
        ${writable ? '<button class="btn btn-primary btn-sm" id="btnSaveNotifEmail">Enregistrer</button>' : ""}
      </div>
    </div>`;

  if (!writable) return;
  $("#btnSaveNotifEmail")!.addEventListener("click", async () => {
    const email = ($("#notifSponsorEmail") as HTMLInputElement).value.trim();
    try {
      await notificationSettingsApi.update(email);
      notify("success", "Email de notification enregistré.");
    } catch (err) {
      notify("error", err instanceof Error ? err.message : "Erreur");
    }
  });
}
